import ProductContractCard from 'components/molecules/card/product-contract/ProductContractCard';
import ListWrapper from 'components/molecules/list-wrapper/ListWrapper';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { useTranslation } from 'react-i18next';
import { ISettlementInfoContractForm } from 'services/music-product-digital/types/form';

const ProductContractTab = <
  Form extends Record<string, ISettlementInfoContractForm[]>
>({
  propertyName = 'contracts',
}) => {
  const { values, status, setFieldValue }: IFormikContextType<Form> =
    useFormikContext<Form>();

  const { t } = useTranslation();

  return (
    <div className='flex flex-col w-full gap-4'>
      <ListWrapper
        isLoading={status?.isLoading}
        items={values[propertyName]}
        item={(contract, index) => (
          <ProductContractCard key={index} contract={contract} />
        )}
      />
    </div>
  );
};

export default ProductContractTab;
